export default __webpack_public_path__ + "static/media/image00.d4f0d1f7.jpg";